import "./index.css";
import React from "react";
import desktopImg from "../../../../assets/media/desktop.png";
import { brandMapping } from "../../../../Utils/Constants";

export default function MobileAccessDisclaimer() {
  const formatFallBackMessage = () => {
    const isAdmin = process.env.REACT_APP_USER === "admin";
    if (isAdmin) return "Ecosystem Admin Hub isn't";

    const hostName = window.location.hostname.toLowerCase();
    const brandInfo = brandMapping.find((brand) =>
      hostName.includes(brand.substring)
    );

    if (brandInfo) return `${brandInfo.brandName} Hub isn't`;
    return "Ecosystem Brand Hub isn't";
  };
  return (
    <section className="mobile-disclaimer">
      <h1 className="mobile-disclaimer__header">
        {formatFallBackMessage()}
        <br />a mobile application.
      </h1>
      <img src={desktopImg} className="mobile-disclaimer__img" alt="logo" />
      <p className="mobile-disclaimer__text">
        Please access via <br />
        desktop or laptop.
      </p>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/screens/LogIn/components/MobileAccessDisclaimer/index.js